<template>
    <section class="custom-container my-1">
    <h2 class="text-center font-lg font-bold mt-4 mb-2">{{ infoPromotions.title ?? ''}}</h2>
    <p class="my-1">{{ infoPromotions.description ?? '' }}</p>

    <div
      ref="productsCarousel"
      class="store-carousel"
      @mouseenter="pauseAutoSlide"
      @mouseleave="startAutoSlide"
      role="region"
      aria-label="Carrusel de promociones"
    >
      <div
        :class="[isMobile ? 'carousel-track' : 'row center gap-16']"
        :style="{ transform: `translateX(-${scrollX}px)` }"
      >
        <div
          v-for="(option, index) in showProducts"
          :key="`option-${index}`"
          class="product-container"
        >
          <a
            :href="option.url"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span>{{ option.store_name }}</span>

            <img
              class="store-icon"
              :src="option.img"
              :alt="option.store_name"
              loading="lazy"
              width="200"
              height="200"
            />

            <div class="mt-1">
              <button class="btn-primary flat">Aprovechar promoción</button>
            </div>
          </a>

          <div class="flex-column mt-1">
            <DateRangeDisplay
              :startDate="utils.dateFormat(option.date)"
              :finishDate="utils.dateFormat(option.finish_date)"
            ></DateRangeDisplay>
          </div>

        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { useScreen } from '../../composables/useScreen'
import utils from '../../composables/utils'
import DateRangeDisplay from '../../global-components/DateRangeDisplay.vue'
import Rating from '../../global-components/Rating.vue'

export default {
  components: {
    Rating,
    DateRangeDisplay
  },
  props: {
    info: String
  },
  setup () {
    const {isMobile} = useScreen();
    return {isMobile}
  },
  data () {
    return {
      infoPromotions: {
        promotions: []
      },
      scrollX: 0,
      intervalId: null,
      step: 0,
      utils
    }
  },
  computed: {
    showProducts () {
      const today = new Date();

      return this.infoPromotions.promotions.filter(product => {
        const start = new Date(product.date);
        const end = new Date(product.finish_date);
        return today >= start && today <= end;
      });
    }
  },
  methods: {
    startAutoSlide() {
      if (!this.isMobile) return;
      if (this.intervalId) return;
      if (!this.$refs.productsCarousel) return

      const carouselWidth = this.$refs.productsCarousel.offsetWidth;

      this.intervalId = setInterval(() => {
        const track = this.$refs.productsCarousel.querySelector('.carousel-track');
        const trackWidth = track.scrollWidth;

        this.scrollX += carouselWidth;
        this.step++;

        if (this.scrollX >= trackWidth / 2) {
          this.scrollX = 0;
          this.step = 0;
        }
      }, 4000);
    },
    pauseAutoSlide() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    },
  },
  beforeUnmount() {
    this.pauseAutoSlide();
  },
  created () {
    try {
      this.infoPromotions = JSON.parse(this.info);
    } catch (e) {
      this.infoPromotions = { promotions: [] };
    }
  },
  mounted () {
    this.startAutoSlide();
  }
}
</script>

<style scoped>
.store-carousel {
  overflow-y: auto;
  position: relative;
  width: 100%;
  margin-top: 1rem;
}

.carousel-track {
  display: flex;
  flex-wrap: nowrap;
  transition: transform 0.6s ease-in-out;
  gap: 22px;
}

.store-icon {
  flex-shrink: 0;
  object-fit: contain;
  transition: transform 0.3s ease;
}

.store-icon:hover {
  transform: scale(1.1);
}

.product-container {
  padding: 8px;
  max-width: 216px;
}

.price-text {
  font-size: 16px;
}

.weight-500 {
  font-weight: 500;
}

.pre-line {
  white-space: pre-line
}

</style>
